import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React, { useState } from 'react'
import JobSupportForm from './enquiryForms/job-support-form'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function GuidenceProcess({title}) {

  return (
   <>
   <section className={`container`}>
  <div className=' '>
   <h5 className={`fs-30 tfs-28 mfs-21 fwb600  fwb600 ${popins.className}`}> <span className={`ylw-clr ${popins.className}`}> Placement Guidance: </span>Your Career with {title}</h5>
   <p className={`fs-16 mfs-15 fwb400 mt24 mmt20 ${quickSand.className}`}>We take pride in contributing to countless successful career transitions across the globe</p>
 
   <div className='guidence-bg mt32 tmt28 mmt24 pd20 '>
      
        <Image src={"/new-course-details/guidence-process.png"} 
        alt='Best Software Training Institute In Chennai'
        width={400} height={400} layout='responsive' priority />

   </div>
   </div>
   </section>

   </>
  )
}
